// tanstack
import { createFileRoute } from '@tanstack/react-router';

// feature-components
import PortfolioDashboardPage from '@/features/energyxplorer/components/PortfolioDashboardPage.tsx';

export const Route = createFileRoute(
  '/$accountId/_user/energyxplorer/portfolio/dashboard',
)({
  component: PortfolioDashboardPage,
  staticData: { crumb: 'glossary:dashboard', hideEnergyAnalysisAppBar: true },
});
